import {ITranscriptionManager, ITranscription } from './interfaces/ITranscriptionManager'
import 'isomorphic-fetch';
import {TranscriptionStorageType } from './interfaces/IStoredTranscription'
import * as DocumentStorage from './office-js/DocumentStorage'
import { SpeakerNameManager } from './SpeakerNameManager';
import { IDocumentStorageTranscriptionDescriptor } from './interfaces/IDocumentStorageTranscriptionDescriptor';

export class DocumentStorageTranscriptionManager implements ITranscriptionManager {
    private descriptor: IDocumentStorageTranscriptionDescriptor;
    private speakerNameManager: SpeakerNameManager | null = null;

    public constructor(descriptor: IDocumentStorageTranscriptionDescriptor) {
        this.descriptor = descriptor;
        if (descriptor == null || descriptor.audioOneDriveItem === undefined || descriptor.transcription === undefined ) {
            throw 'Invalid descriptor provided to DocumentStorageTranscriptionManager';
        }

        this.speakerNameManager = new SpeakerNameManager(this.descriptor.transcription);
    }

    public GetTranscription(): ITranscription {
        return this.descriptor.transcription;
    }

    public async UpdateTranscriptionSegment(segmentIndex: number, segmentText: string, speakerName: string | null, updateAll: boolean) {
        if (this.descriptor.transcription == null)
            throw new Error("this.transcription is null");
        
        if (this.descriptor.transcription.transcriptSegments == null)
            throw new Error("this.transcription.transcriptSegments is null");

        if (segmentIndex < 0 || segmentIndex >= this.descriptor.transcription.transcriptSegments.length)
            throw new Error('Invalid segment index');

        this.descriptor.transcription.transcriptSegments[segmentIndex].text = segmentText;

        if (this.speakerNameManager != null && speakerName != null)
            this.speakerNameManager.UpdateSpeakerName(segmentIndex, speakerName, updateAll);

        await DocumentStorage.WriteStoredTranscription(this.GetStoredTranscription());
    }

    public GetStoredTranscription() {
        return {
            storageType: TranscriptionStorageType.DocumentStorage,
            descriptor: this.descriptor
        };
    }
}